import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FEATURE } from '@src/constants/package';
import { getMinPackageForFeature } from '@src/services/package';
import { useMappingPackage } from './useMappingPackage';

// Package name + CTA target for the AI narration paywall, shared by the 2 upload
// popups and the in-editor dialog. No code to upgrade from → undefined, CTA falls
// back to the pricing page.
const useAINarrationUpgrade = () => {
  const { i18n } = useTranslation();
  const { packages, getUpgradePackageCode } = useMappingPackage();
  const { usingPackage } = useSelector((state) => state.user);

  // Cheapest tier that carries the feature — only its level and name are used.
  const minPackage = useMemo(
    () =>
      getMinPackageForFeature({
        packages,
        feature: FEATURE.AI_GENERATE_NARRATION,
      }),
    [packages],
  );

  return {
    upgradePkgName:
      minPackage?.name?.[i18n.language] || minPackage?.name?.en || 'VIP',
    // Matched on the user's own type/expiresIn, not an arbitrary variant of that level
    targetPackageCode: getUpgradePackageCode({
      level: usingPackage?.level,
      type: usingPackage?.type,
      expiresIn: usingPackage?.expiresIn,
      targetLevel: minPackage?.level,
    }),
  };
};

export default useAINarrationUpgrade;
